<span *ngIf="markdownFileContent | isNotNullNorUndefinedNorWhiteString"
      [innerHTML]="markdownFileContent"
></span>
